import React from 'react';
import { Link } from 'react-router-dom';
import './Support.css';
import packageJson from '../../package.json';

interface SupportProps {
  user?: any;
}

const Support: React.FC<SupportProps> = ({ user }) => {
  return (
    <div className="support-page">
      <div className="support-content">
        <h1>Support & About</h1>

        <section className="about-section">
          <h2>About Simple Baby Sleep</h2>
          <p>
            Simple Baby Sleep is a focused, easy-to-use sleep tracking app designed to help
            parents monitor their baby's sleep patterns without unnecessary complexity.
          </p>
          <p>
            Our mission is to make sleep tracking simple and stress-free, giving you the
            insights you need to understand your baby's sleep patterns and help them
            (and you!) get better rest.
          </p>
          <p className="version-info">
            Current version: <strong>v{packageJson.version}</strong>
          </p>
        </section>

        <section className="support-section">
          <h2>Get Support</h2>
          <p>
            We're here to help! If you have questions, encounter any issues, or have
            suggestions for improving the app, please don't hesitate to reach out.
          </p>
          <div className="contact-info">
            <p>
              <strong>Email us:</strong>{' '}
              <a href="mailto:hello@simplebabysleep.com" className="email-link">
                hello@simplebabysleep.com
              </a>
            </p>
            <p className="response-time">
              We typically respond within 24-48 hours.
            </p>
          </div>
        </section>

        <section className="feedback-section">
          <h2>Share Your Feedback</h2>
          <p>
            Your feedback helps us make Simple Baby Sleep better for all parents.
            We'd love to hear about your experience using the app!
          </p>
          <a href="/feedback" className="feedback-link">
            Give Feedback →
          </a>
        </section>

        <section className="commitment-section">
          <h2>Our Commitment</h2>
          <ul>
            <li>
              <strong>Privacy First:</strong> We respect your privacy and never sell
              your data to third parties.
            </li>
            <li>
              <strong>Simple & Focused:</strong> We keep the app focused on what matters
              most—tracking sleep without unnecessary features.
            </li>
            <li>
              <strong>Continuously Improving:</strong> We're constantly working to make
              the app better based on your feedback.
            </li>
          </ul>
        </section>

        <div className="support-footer">
          <Link to="/welcome" className="back-link">← Back to Home</Link>
          <Link to="/privacy" className="privacy-link">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default Support;
